import { FC, useState } from "react";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import MainHeading from "../../components/Text";
import { FormControl, Select, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { changeUser } from "../../redux/actions/userActions";
import { useDispatch, useSelector } from "react-redux";

const MainContainer = styled("div")(({ theme }) => ({
  width: "fit-content",
  maxWidth: "100%",
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "flex-start",
  color: theme.palette.text.primary,
  padding: "30px",
  paddingTop: "0px",

  [theme.breakpoints.down("smd")]: {
    padding: "20px",
    marginTop: "-20px",
  },
}));

const SubContainer = styled("div")(({ theme }) => ({
  width: "calc( 33% - 30px )",
  minWidth: "300px",
  backgroundColor: theme.palette.primary.main,
  borderRadius: "8px",
  padding: "20px",
  cursor: "pointer",
  margin: "15px",
  minHeight: "155px",

  [theme.breakpoints.down("smd")]: {
    width: "100%",
    margin: "10px 0px",
  },
}));

const Heading = styled("div")(({ theme }) => ({
  fontSize: "25px",
  fontFamily: "Righteous",
  color: theme.palette.background.default,
}));

const Text = styled("div")(({ theme }) => ({
  fontSize: "15px",
  fontFamily: "Poppins",
  color: theme.palette.background.default,
  marginTop: "10px",
}));

const Index: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const userRoles = ["New User", "Voter", "DApp"];
  const userRole = useSelector((state: any) => {
    return state.userReducer.user;
  });
  const dispatch = useDispatch();
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          whiteSpace: "break-spaces",
          alignItems: "center",
        }}
      >
        <Text
          sx={{
            color: theme.palette.text.primary,
          }}
        >
          Switch As {"  "}
        </Text>
        <FormControl>
          <Select
            native
            inputProps={{ id: "role" }}
            onChange={(e) => {
              dispatch(changeUser(e.target.value as string));
            }}
            value={userRole}
          >
            {userRoles.map((role, index) => (
              <option key={index} value={role}>
                {role}
              </option>
            ))}
          </Select>
        </FormControl>
      </div>
      <MainHeading
        fontSize={30}
        fontWeight={700}
        color={theme.palette.primary.main}
        style={{
          fontFamily: "Righteous",
          padding: isMobile ? "10px 30px" : "10px 50px",
        }}
      >
        Dashboard Menu
      </MainHeading>

      <MainContainer>
        <SubContainer
          onClick={() => {
            navigate("/all-dapps");
          }}
        >
          <Heading>Listed DApps</Heading>
          <Text>View all the DApps listed on DecentrAds.</Text>
        </SubContainer>
        {userRole === "New User" && (
          <SubContainer
            onClick={() => {
              navigate("/dapp-register");
            }}
          >
            <Heading>Register DApp</Heading>
            <Text>
              Register your DApp on DecentrAds and start getting Ad proposals.
            </Text>
          </SubContainer>
        )}
        {userRole === "New User" && (
          <SubContainer
            onClick={() => {
              navigate("/voter-register");
            }}
          >
            <Heading>Register Voter</Heading>
            <Text>
              Register to become part of DAO and contribute for the ecosystem.
            </Text>
          </SubContainer>
        )}
        {userRole === "New User" && (
          <SubContainer
            onClick={() => {
              navigate("/create-ad-proposal");
            }}
          >
            <Heading>Create Ad Proposal</Heading>
            <Text>Create Ad Proposal for your desired DApps.</Text>
          </SubContainer>
        )}
        {userRole === "Voter" ||
          (userRole === "DApp" && (
            <SubContainer
              onClick={() => {
                navigate("/my-ads");
              }}
            >
              <Heading>Review Ads</Heading>
              <Text>Review and approve ads for your desired DApps.</Text>
            </SubContainer>
          ))}
        {userRole === "Voter" && (
          <SubContainer
            onClick={() => {
              navigate("/dapp-report");
            }}
          >
            <Heading>Report Dapp</Heading>
            <Text>
              Report a DApp if it is not working or if it is not listed on
            </Text>
          </SubContainer>
        )}
        {userRole === "Voter" && (
          <SubContainer
            onClick={() => {
              navigate("/profile");
            }}
          >
            <Heading>My Profile</Heading>
            <Text>View your profile and perform required actions.</Text>
          </SubContainer>
        )}
      </MainContainer>
    </>
  );
};

export default Index;
